import { render } from "./CreateReturnShippingInfo.vue?vue&type=template&id=6060b8bc&scoped=true"
import script from "./CreateReturnShippingInfo.vue?vue&type=script&lang=js"
export * from "./CreateReturnShippingInfo.vue?vue&type=script&lang=js"

import "./CreateReturnShippingInfo.vue?vue&type=style&index=0&id=6060b8bc&scoped=true&lang=css"
import "./CreateReturnShippingInfo.vue?vue&type=style&index=1&id=6060b8bc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6060b8bc"]])

export default __exports__